import React from 'react';
import { Link } from 'react-router-dom';

const LatestArticles = ({ blogPosts }) => { // Receive the 'blogPosts' prop
    const latestPosts = blogPosts.slice().sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate)).slice(0, 3);

    return (
        <section className="latest-articles">
            <h2>Latest Articles</h2>
            <div className="post-grid">
                {latestPosts.map((post) => (
                    <article key={post.id} className="blog-post-card">
                        <Link to={post.link}>
                            <div className="post-image">
                                <img src={post.imageUrl} alt={post.title} loading="lazy"/>
                            </div>
                            <div className="post-details">
                                <h3>{post.title}</h3>
                                <p className="excerpt">{post.excerpt.substring(0, 100)}...</p>
                                <div className="post-meta">
                                    <span className="author">{post.author}</span>
                                    <span className="date">
                                        {new Date(post.publishedDate).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}
                                    </span>
                                </div>
                                <span className="read-more">Read More &rarr;</span>
                            </div>
                        </Link>
                    </article>
                ))}
            </div>
        </section>
    );
};

export default LatestArticles;